import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=cd93bc3c"
import script from "./sidebar-item.vue?vue&type=script&lang=js"
export * from "./sidebar-item.vue?vue&type=script&lang=js"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=cd93bc3c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports